import { throttle } from "../utils";

jQuery(function ($) {
    const desktopMediaQuery = window.matchMedia('(min-width: 1280px)');

    $('header.type-eu nav').on('click', '.dropdown-menu', function (e) {
        if (desktopMediaQuery.matches) {
            e.stopPropagation();
        }
    });

    $('header.type-eu nav').on('mouseenter', '.dropdown', function () {
        if (!desktopMediaQuery.matches) {
            return;
        }

        if (!$(this).hasClass('show')) {
            $(this).find('[data-toggle="dropdown"]').dropdown('toggle');
        }
    });

    $('header.type-eu nav').on('mouseleave', '.dropdown', function () {
        if (!desktopMediaQuery.matches) {
            return;
        }

        if ($(this).hasClass('show')) {
            $(this).find('[data-toggle="dropdown"]').dropdown('toggle');
        }
    });

    // "Support" menu item dropdown
    $('header.type-eu nav .dropdown > .nav-link').on('click', function (event) {
        if ($(this).attr('href') && $(this).attr('href').startsWith('#')) {
            event.preventDefault();
            event.stopPropagation();

            if (!desktopMediaQuery.matches) {
                $(this).find('+ [data-toggle="dropdown"]').dropdown('toggle');
            }
        }
    });

    $(window).on('resize', throttle(function () {
        // Close mobile menu on resize 
        if (desktopMediaQuery.matches && $('#mainnav').hasClass('show')) {
            $('#mainnav').collapse('hide');
        }
    }, 100));

    // Handle open megamenu clicks

    $('ul.dropdown-menu.depth_0').on('click', function(event){
        var events = $._data(document, 'events') || {};
        events = events.click || [];
        for(var i = 0; i < events.length; i++) {
            if(events[i].selector) {
  
                //Check if the clicked element matches the event selector
                if($(event.target).is(events[i].selector)) {
                    events[i].handler.call(event.target, event);
                }
  
                // Check if any of the clicked element parents matches the 
                // delegated event selector (Emulating propagation)
                $(event.target).parents(events[i].selector).each(function(){
                    events[i].handler.call(this, event);
                });
            }
        }
        event.stopPropagation(); 
    });
});
